import classNames from 'classnames'
import style from './style.module.scss'
import { useLocation } from 'react-router-dom'
import { Button, Header, Text } from '@crossfit/design-system'
import { ReactComponent as ArrowRightIcon } from 'components/Admin/images/arrow-right.svg'
import link from 'components/Admin/images/link.svg'
import { useIsLaptopOrAbove } from 'hooks/useMediaQuery'
import { useSelector } from 'react-redux'
import { getAffiliate } from 'store/selectors'

const MAIN_SITE_URL = import.meta.env.VITE_MAIN_SITE_URL
const GAMES_SITE_URL = import.meta.env.VITE_GAMES_SITE_URL

export type PageHeaderProps = {
  title: string
  hideLinks?: boolean
  showStaffDescription?: boolean
  onBasicInfoClick?: () => void
  onHighlightsClick?: () => void
  onBioClick?: () => void
  onPhotosClick?: () => void
  onCoachesClick?: () => void
}

export default function PageHeader(props: PageHeaderProps) {
  const affiliateDetail = useSelector(getAffiliate)
  const isDirectoryPage = location.pathname.includes('directory-page')
  const isLaptopOrAbove = useIsLaptopOrAbove()
  const affiliatePath = `${MAIN_SITE_URL}/affiliate/${affiliateDetail.id}/${affiliateDetail.slug}`
  const gamesPath = `${GAMES_SITE_URL}/affiliate/${affiliateDetail.id}`

  return (
    <section
      className={classNames(style.container, {
        [style.hiddenLinks]: props.hideLinks === true,
      })}
    >
      <div className={style.topContainer}>
        <div className={style.nameContainer}>
          <Header
            as='h1'
            size='md'
            dangerousHTML={`${props.title} ${
              isLaptopOrAbove ? `${affiliateDetail.name}` : ''
            }`}
          />
          {props.showStaffDescription && (
            <Text
              dangerousHTML={
                'Use <a style="text-decoration: underline; color: blue" href="https://trainerdirectory.crossfit.com/request" target="_blank">this </a> form to submit any updates or questions regarding your trainer data. Check out <a style="text-decoration: underline; color: blue" target="_blank" href="https://www.crossfit.com/courses-near-you">courses near you</a>'
              }
              type={'body'}
              size={'sm'}
              as='div'
            />
          )}
        </div>
        {isDirectoryPage ? (
          <div className={style.buttonContainer}>
            <a
              href={affiliatePath}
              target='_blank'
              rel='noreferrer'
              onMouseDown={(e) => e.preventDefault()}
            >
              <Button
                variant='secondary'
                color='white'
                size='sm'
                className={style.button}
              >
                View Directory Page
                <ArrowRightIcon />
              </Button>
            </a>
            <a
              href={gamesPath}
              target='_blank'
              rel='noreferrer'
              onMouseDown={(e) => e.preventDefault()}
            >
              <Button
                variant='secondary'
                color='white'
                size='sm'
                className={style.button}
              >
                View Games Page
                <ArrowRightIcon />
              </Button>
            </a>
          </div>
        ) : null}
      </div>
      {props.hideLinks != true && (
        <div className={style.bottomContainer}>
          <div className={style.linkContainer} onClick={props.onBasicInfoClick}>
            <Text size='md' type='button' bold={true}>
              Basic Info
            </Text>
            <img src={link} className={style.linkIcon} />
          </div>
          <div
            className={style.linkContainer}
            onClick={props.onHighlightsClick}
          >
            <Text size='md' type='button' bold={true}>
              Highlights
            </Text>
            <img src={link} className={style.linkIcon} />
          </div>
          <div className={style.linkContainer} onClick={props.onBioClick}>
            <Text size='md' type='button' bold={true}>
              Bio
            </Text>
            <img src={link} className={style.linkIcon} />
          </div>
          <div className={style.linkContainer} onClick={props.onPhotosClick}>
            <Text size='md' type='button' bold={true}>
              Photos
            </Text>
            <img src={link} className={style.linkIcon} />
          </div>
          <div className={style.linkContainer} onClick={props.onCoachesClick}>
            <Text size='md' type='button' bold={true}>
              Coaches
            </Text>
            <img src={link} className={style.linkIcon} />
          </div>
        </div>
      )}
    </section>
  )
}
